/** Over the whole screen: the soft vignette, a move's flash, frost creeping in and the letterbox. */
import { settings } from '../../settings';
import { frostVignette } from '../iceFx';
import { canvas, ctx2d } from '../pixel';
import { FRAMES } from '../sprites';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'vignette',
  layer: 'screen',
  order: 100,
  state: () => ({ img: null as HTMLCanvasElement | null }),
  draw(f, s) {
    // Soft vignette pulls the eye to the centre: painted once per window size at a sixteenth of
    // the pixels (a quarter each way) and stretched smoothly, not a full-screen gradient every frame.
    const W = Math.max(1, Math.ceil(f.screenW / 4));
    const H = Math.max(1, Math.ceil(f.screenH / 4));
    let c = s.img;
    if (!c || c.width !== W || c.height !== H) {
      c = s.img = canvas(W, H);
      const g = ctx2d(c);
      const vg = g.createRadialGradient(
        W / 2,
        H / 2,
        Math.min(W, H) * 0.35,
        W / 2,
        H / 2,
        Math.max(W, H) * 0.75,
      );
      vg.addColorStop(0, 'rgba(10,8,14,0)');
      vg.addColorStop(1, 'rgba(10,8,14,0.45)');
      g.fillStyle = vg;
      g.fillRect(0, 0, W, H);
    }
    const mg = f.mg;
    mg.imageSmoothingEnabled = true;
    mg.drawImage(c, 0, 0, f.screenW, f.screenH);
    mg.imageSmoothingEnabled = false;
  },
});

registerRenderPass({
  id: 'flash',
  layer: 'screen',
  order: 200,
  draw({ mg, effects: fx, screenW: w, screenH: h }) {
    if (!(settings.flash && fx.flash.a > 0.01)) return;
    // Screen flash in the move's colour, strongest at the centre.
    const gr = mg.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, Math.max(w, h) * 0.7);
    gr.addColorStop(0, `rgba(${fx.flash.col},${fx.flash.a * 0.55})`);
    gr.addColorStop(1, `rgba(${fx.flash.col},${fx.flash.a * 0.15})`);
    mg.fillStyle = gr;
    mg.fillRect(0, 0, w, h);
  },
});

registerRenderPass({
  id: 'frost',
  layer: 'screen',
  order: 300,
  draw({ mg, effects: fx, W, H, px }) {
    if (!(settings.flash && fx.frost > 0.01)) return;
    // Frost creeping in round the screen (เหมันต์สะกดธาร's last cut), in hard pixels, fading in steps.
    mg.globalAlpha = Math.ceil(fx.frost * FRAMES) / FRAMES;
    mg.drawImage(frostVignette(W, H), 0, 0, W * px, H * px);
    mg.globalAlpha = 1;
  },
});

registerRenderPass({
  id: 'letterbox',
  layer: 'screen',
  order: 400,
  draw({ mg, cine, screenW: w, screenH: h }) {
    if (!(cine > 0.01)) return;
    // Letterbox bars slide in from top and bottom.
    const bar = Math.round(h * 0.075 * cine);
    mg.fillStyle = '#05040a';
    mg.fillRect(0, 0, w, bar);
    mg.fillRect(0, h - bar, w, bar);
  },
});
